import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class OpenInBrowserMessage extends WebViewMessage {
  public url?: string;
  public method?: string;
  public body?: string;
  public userName?: string;
  public password?: string;

  public constructor(url?: string) {
    super(MessageType.OpenInBrowser);
    this.url = url;
  }
}
